module.exports = __webpack_public_path__ + "img/alarm_on.37322b67.svg";